// extracted by mini-css-extract-plugin
module.exports = {"QuizList":"_1DltaZPhnIQigqfUDZNubp"};